/**
 * @file TransferLotMovedDialog.tsx
 * @description Расхождение адресов при проведении перемещения (409 `lot_moved`,
 * phase19.23 этап B).
 *
 * Партию переставили между составлением документа и подписью. Подставлять
 * новый адрес молча нельзя: в накладной стоит конкретное место, и кладовщик
 * должен увидеть, что изменилось, прежде чем проводить. Одно действие на все
 * строки — «Обновить строки» (`POST /:id/refresh-rows`).
 */

import { Button } from "../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import type { TransferLotMovedItem } from "../../../lib/api-transfers";

interface Props {
  items: TransferLotMovedItem[];
  busy: boolean;
  onRefresh: () => void;
  onClose: () => void;
}

export function TransferLotMovedDialog({ items, busy, onRefresh, onClose }: Props) {
  return (
    <Dialog open={items.length > 0} onOpenChange={(o) => !o && onClose()}>
      <DialogContent fullScreen className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Партии переставили после составления документа</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-3">
          <p className="text-sm text-on-surface-variant">
            Адрес в строках больше не совпадает с фактическим. Обновите строки —
            «Откуда» пересчитается по текущим ячейкам, после чего документ можно
            провести.
          </p>
          <ul className="flex flex-col gap-2">
            {items.map((row, index) => (
              <li
                key={row.itemId ?? row.lotId ?? index}
                className="rounded-lg border border-amber-500/40 bg-amber-500/5 p-3 text-sm"
              >
                <div className="font-mono">{row.batchNumber ?? "партия"}</div>
                <div className="text-xs text-on-surface-variant">
                  сейчас лежит в {row.actualBinCode ?? "ячейке без адреса"}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <DialogFooter>
          <Button variant="ghost" className="min-h-[56px]" onClick={onClose} disabled={busy}>
            Закрыть
          </Button>
          <Button className="min-h-[56px]" onClick={onRefresh} disabled={busy}>
            {busy ? "Обновляем…" : "Обновить строки"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
